module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-300-[4]3.bd60fa9.woff2";